/**
 * 内部調査用ツールの表示制御フラグ。
 *
 * デジタコ取込ファイル明細ビューア（取込ファイルから生まれた生データ／集計勤怠を
 * 突合表示する調査用画面）など、社内調査専用の導線を local 環境でのみ表示するために使う。
 *
 * ※ このツールが不要になった場合は、本ファイルと以下の参照箇所をまとめて削除すればよい:
 *    - frontend: DezitakoKintaiKakunin の日報番号リンク / pages.ts の filedetail ルート /
 *      DezitakoFileDetail.tsx / service の getFileDetail / TDegitako の関連型
 *    - backend: GetFileDetailAction / DezitakoKintaiKakuninService.GetFileDetail /
 *      DezitakoFileDetailInfo
 */

const IS_INTERNAL_DEBUG_TOOL_ENABLED_INNER = (process.env.REACT_APP_ENVIRONMENT_NAME ?? "").includes("ローカル")

export const IS_INTERNAL_DEBUG_TOOL_ENABLED = IS_INTERNAL_DEBUG_TOOL_ENABLED_INNER
